import { module as ModuleJS } from "modujs";

export default class extends ModuleJS {
    constructor(m) {
        super(m);

        this.input = this.$('input')[0];
        this.openButtons = this.$('open');
        this.closeButtons = this.$('close');

        this.SEARCH_ACTIVE_CLASS = "is-search-active";
    }

    init() {
        this.onKeyup = this.onKeyup.bind(this);
        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);

        this.bindEvents();
    }

    show() {
        document.documentElement.classList.add(this.SEARCH_ACTIVE_CLASS);
        this.input.focus();
        
        setTimeout(() => {
            this.input.focus();
        }, 1500);

        document.addEventListener("keyup", this.onKeyup);
    }

    hide() {
        document.documentElement.classList.remove(this.SEARCH_ACTIVE_CLASS);
        document.removeEventListener("keyup", this.onKeyup);
    }

    onKeyup(e) {
        const key = e.key || e.keyCode;
        
        // ESC
        if (key === 27 || key === "Escape") {
            this.hide();
        }
    }

    bindEvents(el) {
        for (const button of this.openButtons) {
            button.addEventListener("click", this.show);
        }

        for (const button of this.closeButtons) {
            button.addEventListener("click", this.hide);
        }
    }

    update(newContainer) {
        this.bindEvents(newContainer);
    }

    destroy(oldContainer) {
    }
}